import styled from 'styled-components';

export const BoxInfo = styled.div`
  display: flex;
  cursor: pointer;
  &:hover span{
    visibility: visible;
  }
`;

export const StyledTooltip = styled.span`
  visibility: hidden;
  width: max-content;
  height: 22px;
  background-color: #707070;
  color: #fff;
  font-weight: 700;
  font-size: 10px;
  line-height: 150%;
  text-align: center;
  border-radius: 6px;
  padding: 3px 6px;
  position: absolute;
  z-index: 1101;
  top: 37px;
  margin-left: -13px;
  &::after{
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #707070 transparent;
  }
`;